<template>

    <video-player ref="playlistsPlayer"
                  id="thePlayer"
                  :options="playerOptions"
                  class="player-fit vjs-big-play-centered"
                  @play="onPlayerPlay($event)"
                  @ready="onPlayerReady($event)"
                  disablepictureinpicture>
    </video-player>

</template>

<script>

    import { videoPlayer } from 'vue-videojs7'

    export default {

        components: {
            videoPlayer
        },

        data () {

            return {

                ENV_CloudFront_Legacy_DNS_Name: process.env.MIX_LEGACY_CLOUDFRONT_DNSNAME,
                ENV_CloudFront_DNS_Name: process.env.MIX_CLOUDFRONT_DNSNAME,
                ENV_Thumbnail_Key: process.env.MIX_BASE_THUMBNAIL_KEY,
                ENV_Legacy_Thumbnails: process.env.MIX_LEGACY_THUMBNAILS_CLOUDFRONT_DNSNAME,

            }
        },

        computed: {

            mediaSrc() {
                if(!this.$root.shared.isLegacyContent) {
                    return this.ENV_CloudFront_DNS_Name + this.$root.shared.playerPayload.storage_url;
                } else {
                    return this.ENV_CloudFront_Legacy_DNS_Name + this.$root.shared.playerPayload.storage_url;
                }
            },

            mediaType() {
                if(!this.$root.shared.isLegacyContent) {
                    return 'application/x-mpegURL'
                } else {
                    return 'video/mp4'
                }
            },

            playerOptions() {

                let posterURL = '';

                if (this.$root.shared.playerPayload.is_hero) {
                    if (this.$root.shared.isLegacyContent) {
                        posterURL = this.ENV_Legacy_Thumbnails + this.$root.shared.playerPayload.hero_thumbnail + '.jpg';
                    } else {
                        posterURL = this.ENV_CloudFront_DNS_Name + this.$root.shared.playerPayload.filename + '/' + this.ENV_Thumbnail_Key + this.$root.shared.playerPayload.hero_thumbnail + '.jpg';
                    }
                } else {
                    if (this.$root.shared.isLegacyContent) {
                        posterURL = this.ENV_Legacy_Thumbnails + this.$root.shared.playerPayload.thumbnail_url;
                    } else {
                        posterURL = this.ENV_CloudFront_DNS_Name + this.$root.shared.playerPayload.thumbnail_url;
                    }
                }

                return {
                    autoplay: false,
                    controls: true,
                    controlBar: {
                        timeDivider: false,
                        durationDisplay: false,
                    },
                    fluid: true,
                    poster: posterURL,
                    sources: [ {
                        src: this.mediaSrc,
                        type: this.mediaType
                    }],
                }

            },

        },

        props: [
            'currentlocale'
        ],

        methods: {

            onPlayerPlay (player) {

                // Let's update the play count for this Content; while we are here, let's check if
                // the Content is in the Current User's Watch Later list, and if so, remove it.

                axios.get('/' + this.currentlocale  + '/content/stats/add-play/' + this.$root.shared.playerPayload.id)
                    .then( response => {
                        this.$root.shared.contentPlays = JSON.stringify(response.data);

                        // If the Content is in the Watch Later playlist, let's remove it from it:
                        axios.get('/' + this.currentlocale  + '/watchlater/removeif/' + this.$root.shared.playerPayload.id)
                            .then((response) => {
                                console.log('Successfully removed this Content from the Watch Later playlist for this User.')
                                console.log('Updating the User Watch Later List...')



                            })
                            .catch((error) => {
                                console.log('ERROR trying to remove this Content from this user\'s Watch Later playlist')
                            })
                    })
                    .catch(error => {
                        console.log('There was an error updating the Play Count for this Content! ERROR: ' + error);
                    });

                console.log('Updated the Content play count!');
            },

            onPlayerReady (player) {
                console.log('player ready!', player)
                console.log('Media Duration: ', player.duration())
                // this.player.play()
            },

            playVideo: function (source) {

                if(this.$root.shared.isLegacyContent) {
                    const video = {
                        withCredentials: false,
                        type: 'video/mp4',
                        src: source
                    }

                    this.$refs.playlistsPlayer.player.src(video);
                    this.$refs.playlistsPlayer.player.controlBar.pictureInPictureToggle.dispose();

                } else {
                    const video = {
                        withCredentials: false,
                        type: 'application/x-mpegurl',
                        src: source,
                    }

                    this.$refs.playlistsPlayer.player.src(video);
                    this.$refs.playlistsPlayer.player.controlBar.pictureInPictureToggle.dispose();
                }
            }
        },

        mounted () {

            Event.listen('updateVideoPlayer', (request) => {
                this.$root.shared.playerPayload = request
                this.$root.shared.isLegacyContent = !!request.legacy
            })

            /*this.playVideo(this.mediaSrc)*/
        }

    }

</script>

<style scoped>

    .player {
        /* position: absolute !important; */
        width: 100%;
        height: 60%;
    }

    .vjs-custom-skin {
        height: 60% !important;
    }

    .vjs-custom-skin /deep/ .video-js {
        height: 60%;
    }

    .player-fit {
        position: relative !important;
        width: 100% !important;
        height: auto !important;
    }

</style>
